import React from 'react'
import { SelectInput, SelectInputProps } from 'react-admin'
import { getTimeLabels } from 'services/utils/date'

const TimePicker: React.FC<SelectInputProps> = (props) => {
  return <SelectInput {...props} choices={getTimeLabels()} fullWidth />
}

export default TimePicker
